module.exports = __webpack_public_path__ + "static/media/presentation.6944a59f.svg";